export default "__VITE_ASSET__jSDu2SGi__"